import React, { Suspense } from "react";

import type { EmailVerificationProps } from "./EmailVerificationInner";

const LazyEmailVerification = React.lazy(() =>
  import("./EmailVerificationInner").then((mod) => ({
    default: mod.default,
  })),
);

const EmailVerification = (props: EmailVerificationProps) => {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[50vh] items-center justify-center p-6 text-sm text-muted-foreground">
          Preparing verification…
        </div>
      }
    >
      <LazyEmailVerification {...props} />
    </Suspense>
  );
};

export default EmailVerification;
export type { EmailVerificationProps } from "./EmailVerificationInner";
